import { Suspense } from "react";
import { useParams } from "react-router";

import useApplication from "../../../clients/applications/useApplication";
import ApplicationPage from "../components/ApplicationPage";
import ApplicationEditor from "../features/ApplicationEditor";

export default function EditApplication() {
    const { applicationDomain } = useParams();
    return (
        <ApplicationPage>
            <header>
                <span>Application</span>
            </header>
            <Suspense fallback={ <span>loading</span> }>
                <ApplicationEditorWithBrand
                    domain={ applicationDomain }
                />
            </Suspense>
        </ApplicationPage>
    );
}

function ApplicationEditorWithBrand(props) {
    const { domain } = props;
    const application = useApplication(domain);
    return (
        <ApplicationEditor
            application={ application }
            domain={ domain }
            key={ domain }
        />
    );
}
